export { PmListingsCarouselSection } from './pm-listings-carousel-section';

export type Props = {
  accountSlug?: string;
  listings: Array<{
    slug: string;
    name?: string;
    city?: string;
    stateOrProvinceLongName?: string;
    galleryAssets: { url?: string }[];
  }>;
};

export const hiddenStyles: React.CSSProperties = {
  transitionDelay: '0.5s',
  transitionProperty: 'visibility',
  transitionTimingFunction: 'linear',
  visibility: 'hidden',
};
